import React from "react";
import noImg from "../assets/images/no-img.jpg"; // ajuste o caminho se necessário

const CircularImage = ({ url, width = "96px", height = "96px", alt = "Imagem" }) => {
  const src = url || noImg;

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      style={{
        display: "inline-block",
        borderRadius: "50%",
        objectFit: "cover",
        backgroundColor: "#F3F4F6",
      }}
      onError={(e) => {
        if (e.currentTarget.src !== noImg) {
          e.currentTarget.src = noImg;
        }
      }}
    />
  );
};

export default CircularImage;